import React, { useRef, useState } from 'react';
import { Form, Input, Button, Typography, message, theme } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import ReCAPTCHAComponent, { ReCAPTCHAComponentRef } from '@/components/ReCAPTCHA';

const { Title, Text } = Typography;
const RECAPTCHA_ENABLED = !!import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const recaptchaRef = useRef<ReCAPTCHAComponentRef>(null);
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const { token } = theme.useToken();

  const onFinish = async (values: { email: string; password: string }) => {
    if (RECAPTCHA_ENABLED && !captchaToken) {
      message.warning('Por favor, complete o captcha.');
      return;
    }
    setLoading(true);
    try {
      await login(values.email, values.password, captchaToken || undefined);
      message.success('Login realizado com sucesso!');
      navigate('/dashboard');
    } catch (error) {
      message.error('Credenciais inválidas. Tente novamente.');
      recaptchaRef.current?.reset();
      setCaptchaToken(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: token.colorBgLayout,
    }}>
      <div style={{
        background: token.colorBgContainer,
        padding: 40,
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        width: '100%',
        maxWidth: 400,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo.png" alt="Layout Sistemas" style={{ height: 60, marginBottom: 16 }} />
          <Title level={3} style={{ margin: 0 }}>Layout Remote</Title>
          <Text type="secondary">Painel Administrativo</Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Por favor, insira seu e-mail' },
              { type: 'email', message: 'E-mail inválido' },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="E-mail" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Por favor, insira sua senha' },
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Senha" />
          </Form.Item>

          <Form.Item>
            <ReCAPTCHAComponent
              ref={recaptchaRef}
              onChange={(value) => setCaptchaToken(value)}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Entrar
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <a href="/forgot-password">Esqueceu a senha?</a>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;